export enum FileSize {
  image = 52428800,
  icon = 128974848,
  companyImage = 3145728,
  favicon = 10240,
  logo = 102400,
}
